<template>
  <div>
    <slot />
  </div>
</template>
<script>
export default {
  name: "MsValidate",
  data() {
    return {
      listInput: [],
      errorFocusable: true,
      listError: [],
    };
  },
  methods: {
    /**
     * Hàm duyệt qua các control input gọi hàm validate của từng control rồi push vào trong listError;
     * Created by LTDAT(22.06.2020)
     */
    validate() {
      const me = this;
      me.errorFocusable = true;
      me.listError = [];
      me.listInput = [];
      this.getListInput(me.$children);
      me.listInput.forEach((item) => {
        if (
          item.validate &&
          typeof item.validate == "function" &&
          !item.disabled
        ) {
          let validateProvider = item.validate();
          let elem = item.$el;
          if(!!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )){
            if (Array.isArray(validateProvider)) {
              validateProvider.forEach((valid) => {
                me.listError.push(valid);
              });
            } else if (validateProvider.isValid) {
              me.listError.push(validateProvider);
            }
          }

        }
      });
      if (me.listError.length > 0) {
        me.$nextTick(() => {
          me.focusFirstError();
        });
        return false;
      }
      return true;
    },
    /**
     * Hàm dùng để focus vào ô lỗi đầu tiên
     * Created by LTDAT(22.06.2020)
     *  */
    focusFirstError() {
      const me = this;
      let listError = me.getListError();
      if (listError[0].gridIns) {
        listError[0].gridIns.cellSelected(listError[0].element);
      } else {
        me.listError[0].element.errorElement.errorScrollElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        var scrollTimeout;
        const intersectionObserver = new IntersectionObserver((entries) => {
          let [entry] = entries;
          if (entry.isIntersecting) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              if(me.errorFocusable){
                me.listError[0].element.focusError();
                me.errorFocusable = false;
              }
            }, 300)
          }
        });
        // start observing
        intersectionObserver.observe(listError[0].element.errorElement.errorScrollElement);
        
      }
    },
    /**
     * Lấy ra list control bị lỗi
     * Created by LTDAT(22.06.2020)
     */
    getListError() {
      const me = this;
      return me.listError;
    },
    /**
     * Xóa toàn bộ trạng thái validate về ban đầu
     * created by LTDAT(22.06.2020)
     */
    reset() {
      const me = this;
      me.getListInput(me.$children);
      me.listInput.forEach((item) => {
        item.errorProvider = {};
      });
    },
    /**
     * Lấy các input cần validate
     */
    getListInput(children) {
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          if (children[i].$children && children[i].$children.length > 0) {
            this.getListInput(children[i].$children);
          }
        }
        let result = children.filter((item) => {
          return !!item.isComponentValidate;
        });
        result && result.length > 0 && this.listInput.push(...result);
      }
    },
  },
};
</script>
